import { useMemo, useReducer } from 'react'
import { reducer, initialState, type State, type Actions } from '../../state'
import { type AsyncDispatch, wrapAsync } from '@sales-center/common'

export function useData() {
  const [state, dispatch] = useReducer(reducer, initialState)

  const asyncDispatch = useMemo(() => wrapAsync(dispatch), [dispatch])

  const value: [State, AsyncDispatch<Actions>] = [state as State, asyncDispatch]

  return {
    value,
  }
}
